// extracted by mini-css-extract-plugin
module.exports = {"flashTitle":"FlashTitle_flashTitle__dtAUW"};